import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';

import './assets/fonts.scss';
import { theme } from './theme';

// eslint-disable-next-line @typescript-eslint/ban-types
export const KlpTheme = (props: React.PropsWithChildren<{}>) => (
    <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
);
